import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";
const { REACT_APP_WOO_COMMERCE_REST_API,REACT_APP_WOO_COMMERCE_CONSUMER_KEY,REACT_APP_WOO_COMMERCE_CONSUMER_SECRET,REACT_APP_PD_WOO_COMMERCE_REST_API,REACT_APP_PD_WOO_COMMERCE_CONSUMER_KEY,REACT_APP_PD_WOO_COMMERCE_CONSUMER_SECRET } = process.env;

const restApi = new WooCommerceRestApi({
    // url: { WOO_COMMERCE_REST_API },
    // consumerKey: { WOO_COMMERCE_CONSUMER_KEY },
    // consumerSecret: { WOO_COMMERCE_CONSUMER_SECRET },
    // version: "wc/v3"
    url: REACT_APP_WOO_COMMERCE_REST_API,
    consumerKey: REACT_APP_WOO_COMMERCE_CONSUMER_KEY,
    consumerSecret: REACT_APP_WOO_COMMERCE_CONSUMER_SECRET,
    version: "wc/v3",
});

const restApi_PD = new WooCommerceRestApi({
    url: REACT_APP_PD_WOO_COMMERCE_REST_API,
    consumerKey: REACT_APP_PD_WOO_COMMERCE_CONSUMER_KEY,
    consumerSecret: REACT_APP_PD_WOO_COMMERCE_CONSUMER_SECRET,
    version: "wc/v3",
});

export {restApi,restApi_PD};